import { axiosClient } from '@nx-frontend/shared/api';
import { NoteDto } from '@nx-frontend/shared/types';
import { generateNoteGlobalId } from '@nx-frontend/shared/utils';

interface CreateWorkspaceNoteParams {
  workspaceId: string;
  noteName?: string;
  parentId?: string;
  globalId?: string | null;
  isPortalShare?: boolean | null;
}

export async function createWorkspaceNote({
  workspaceId,
  noteName = 'New page',
  parentId = 'default',
  globalId = null,
  isPortalShare = false,
}: CreateWorkspaceNoteParams): Promise<NoteDto> {
  const note = (
    await axiosClient.post<NoteDto>(`/v2/api/web-editor/notes/create`, {
      workspaceId,
      noteId: globalId ?? generateNoteGlobalId(),
      note: {
        textVersion: 2,
        title: noteName,
        parentId,
        is_portal_share: isPortalShare,
      },
    })
  ).data;
  return note;
}
